<template>
  <div class="animated fadeIn">
    <GeneralSpinner v-if="notifications==[]"></GeneralSpinner>
    <div class="page-card-margin row" v-else="">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong><i class="fa fa-bell-o"></i>{{web_texts.notifications}}</strong>
          </div>
          <div class="card-block">
            <vue-good-table :columns="columns" :rows="notifications" :paginate="true" :perPage="10"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Notifications';
  import trans_es from '../translates/es/Notifications';
  import middleware from "../utilities/middlewares";
  import constants from '../constants'
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: '',
    data() {
      return {
        web_texts: {"notifications": "Notificacions"},
        notifications: [],
        all_notifications: [],
        systems: [],
        system_selected: [],
        spinner_notification: true,
        columns: [
          {
            label: 'Data',
            field: 'date',
            html: true
          },
          {
            label: 'Text',
            field: 'title',
            html: true
          }
        ],
      }
    },
    created(){
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
    },
    mounted() {
      window.localStorage.setItem('real_time_control', '["notifications","notifications"]');
      var out = this;
      setTimeout(function () {
        out.getNotifications();
      }, 750);
    },
    components:{
      GeneralSpinner
    },
    methods: {
      // Llegir les notificacions del sistema
      getNotifications() {
        axios.get(constants.ROOT_URL + '/api/v1/notifications/get_notifications_by_system')
          .then((response) => {
            var all_notifications_loc = response.data;
            this.findNotificationSelection(all_notifications_loc);
            this.spinner_notification=false;
          }, (response) => {
            console.log(response.data);
          });
      },
      // funcio que crida a la funcio per a imprimir les notificacions depenent del id del sistema amb una closure de les notificacions ja descarregades
      findNotificationSelection(all_notifications_loc) {
        var system_id = JSON.parse(window.localStorage.getItem('system')).id;
        var noti_par=null;

        console.log(all_notifications_loc);

        for(var i=0; i<all_notifications_loc.length; i++){
          if(all_notifications_loc[i].system_id===system_id){
            this.printNotificationSelection(noti_par=all_notifications_loc[i].value);
          }
        }
      },
      // Imprimir les notificacions
      printNotificationSelection(notifications_loc) {
        console.log(notifications_loc);
        for (var i = 0; i < notifications_loc.length; i++) {
          var n_position = JSON.parse(notifications_loc[i].notification);
          this.notifications.push({
            date: moment(notifications_loc[i].created_at, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm:ss'),
            title: '<b>' + n_position[1] + '</b> <br>' + n_position[3]
          });
        }
        console.log(this.notifications);
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Notifications.vue?35264d2f